import { ChangeDetectorRef, Component, inject, OnInit, signal, ChangeDetectionStrategy } from '@angular/core';
import { Banner2Model } from '../../../models/layout/banner2-model';
import { RouterModule } from '@angular/router';
import { LocalizationService } from '../../../Services/localization-service';
import {  TranslateService } from '@ngx-translate/core';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-banner2-component',
  imports: [
    RouterModule,
],
  templateUrl: './banner2-component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './banner2-component.scss'
})
export class Banner2Component implements OnInit {
  private readonly localizationService = inject(LocalizationService);
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly translateService = inject(TranslateService);

  banner2Model: Banner2Model = {
    title: this.translateService.instant('Banner2InfoDtoTitle'),
    buttonText: this.translateService.instant('Banner2InfoDtoButtonText'),
    text1: this.translateService.instant('Banner2InfoDtoText1'),
    text2: this.translateService.instant('Banner2InfoDtoText2'),
    text3: this.translateService.instant('Banner2InfoDtoText3'),
    text4: this.translateService.instant('Banner2InfoDtoText4'),
    text5: this.translateService.instant('Banner2InfoDtoText5')
  };
  currentLang = signal<string>(environment.defaultLang);

  ngOnInit(): void {

    this.localizationService.getLanguage().subscribe(lang => {
      this.currentLang.set(lang);
      this.cdr.detectChanges();
    });
  }
}
